export const chartColors = {
  "1": "hsl(var(--chart-1))",
  "2": "hsl(var(--chart-2))",
  "3": "hsl(var(--chart-3))",
  "4": "hsl(var(--chart-4))",
  "5": "hsl(var(--chart-5))",
  "6": "hsl(var(--chart-6))",
  "7": "hsl(var(--chart-7))",
  "8": "hsl(var(--chart-8))",
  "9": "hsl(var(--chart-9))",
  "10": "hsl(var(--chart-10))",
  "12": "hsl(var(--chart-12))",
  "13": "hsl(var(--chart-13))",
  "14": "hsl(var(--chart-14))",
  "15": "hsl(var(--chart-15))",
  "16": "hsl(var(--chart-16))",
  "17": "hsl(var(--chart-17))",
  "18": "hsl(var(--chart-18))",
  "19": "hsl(var(--chart-19))",
  "20": "hsl(var(--chart-20))",
  "21": "hsl(var(--chart-21))",
}
